// Auto-scroll helpers shared by the photo (/main) and video (/video_template)
// generation flows. As the user answers each option row we walk them down to the
// next row, then to the Generate button, and to the results / error when those
// appear. Works whether the scrolling happens inside a container (desktop, where
// the controls column has its own overflow) or on the window (mobile).

// Nearest scrollable ancestor of `el`, or null meaning "scroll the window".
function getScrollParent(el) {
    let node = el && el.parentElement;
    while (node) {
        const overflowY = window.getComputedStyle(node).overflowY;
        const scrollable = overflowY === 'auto' || overflowY === 'scroll';
        if (scrollable && node.scrollHeight > node.clientHeight + 1) return node;
        node = node.parentElement;
    }
    return null;
}

// Height of the fixed mobile header if it's currently shown (0 otherwise), so a
// window scroll doesn't tuck the target underneath it.
function getFixedHeaderOffset() {
    const header = document.querySelector('.mobileHeader');
    if (!header) return 0;
    const style = window.getComputedStyle(header);
    if (style.display === 'none' || style.visibility === 'hidden') return 0;
    return header.getBoundingClientRect().height;
}

// Smoothly bring `el` near the top of its scroll container (or the window),
// leaving `offset` px of breathing room above it (plus any fixed header).
export function scrollNear(el, offset = 16) {
    if (!el) return;
    const parent = getScrollParent(el);
    if (parent) {
        const rect = el.getBoundingClientRect();
        const pRect = parent.getBoundingClientRect();
        const top = parent.scrollTop + (rect.top - pRect.top) - offset;
        parent.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    } else {
        const top = window.scrollY + el.getBoundingClientRect().top - offset - getFixedHeaderOffset();
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
}

// Wait for freshly-rendered content to lay out, then scroll to it. `getEl` may be
// an element or a function returning one.
export function scrollNearAfterRender(getEl, offset = 16) {
    setTimeout(() => scrollNear(typeof getEl === 'function' ? getEl() : getEl, offset), 60);
}
